export const URL_PREFIX = /^https?:\/\//i;

export const IPFS_PREFIX = /^ipfs:\/\//i;

export const HEX_REGEXP = /^(?:0x)?[\da-fA-F]+$/;
export const HEX_REGEXP_WITH_0X = /^0x[\da-fA-F]+$/;

export const FILE_EXTENSION = /\.([\da-z]+)$/i;

export const BLOCK_HEIGHT = /^\d+$/;

export const ADDRESS_REGEXP = /^0x[a-fA-F\d]{40}$/;
